export default "__VITE_ASSET__21b54b2e__"